"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var editor_web_1 = require("@21st-night/editor-web");
function createCardDocument() {
    return {
        answer: editor_web_1.generateRichTextDocument(null, false),
        category: null,
        explanation: editor_web_1.generateRichTextDocument(null, false),
        question: editor_web_1.generateRichTextDocument(),
        summary: editor_web_1.generateRichTextDocument(null, false),
        subcategories: [],
    };
}
exports.default = createCardDocument;
//# sourceMappingURL=createCardDocument.js.map